export const getValidShortcutKey = (e: KeyboardEvent): "k" | "meta" | "" => {
  if (e.key.toLowerCase() === "k") return "k";
  if (e.key === "Meta" || e.key === "Control") return "meta";
  return "";
};

export const getOSKeyboardShortcutText = () => {
  let shortcutText = "Ctrl K";

  if (
    typeof navigator !== "undefined" &&
    navigator?.userAgent.toLocaleLowerCase().includes("mac")
  ) {
    shortcutText = "⌘ K";
  }

  return shortcutText;
};
